export const TOGGLE_FORM = "TOGGLE_FORM";
export const DISMISS_FORM = "DISMISS_FORM";

export const TOGGLE_REPORT = "TOGGLE_REPORT";
export const DISMISS_REPORT = "DISMISS_REPORT";

export const TOGGLE_SHIPMENT_ATTACHMENT = "TOGGLE_SHIPMENT_ATTACHMENT";
export const DISMISS_SHIPMENT_ATTACHMENT = "DISMISS_SHIPMENT_ATTACHMENT";

export const TOGGLE_ORDER_ATTACHMENT = "TOGGLE_ORDER_ATTACHMENT";
export const DISMISS_ORDER_ATTACHMENT = "DISMISS_ORDER_ATTACHMENT";

export const TOGGLE_SHIPMENT_STATUS = "TOGGLE_SHIPMENT_STATUS";
export const DISMISS_SHIPMENT_STATUS = "DISMISS_SHIPMENT_STATUS";

export const TOGGLE_ARCHIVED_SHIPMENTS = "TOGGLE_ARCHIVED_SHIPMENTS";

export const TOGGLE_PLANNED_ORDERS = "TOGGLE_PLANNED_ORDERS";

export const SWITCH_TABLE_COMPONENT = "SWITCH_TABLE_COMPONENT";


export const toggleForm = (formName, addOrEdit) => ({
  type: TOGGLE_FORM,
  formName: formName,
  addOrEdit: addOrEdit
});
export const dismissForm = () => ({
  type: DISMISS_FORM
});

export const toggleShipmentAttachment = () => ({
  type: TOGGLE_SHIPMENT_ATTACHMENT
});

export const dismissShipmentAttachment = () => ({
  type: DISMISS_SHIPMENT_ATTACHMENT
});

export const toggleOrderAttachment = () => ({
  type: TOGGLE_ORDER_ATTACHMENT
});

export const dismissOrderAttachment = () => ({
  type: DISMISS_ORDER_ATTACHMENT
});

export const toggleShipmentStatus = () => ({
  type: TOGGLE_SHIPMENT_STATUS
});

export const dismissShipmentStatus = () => ({
  type: DISMISS_SHIPMENT_STATUS
});

export const toggleArchivedShipments = () => ({
  type: TOGGLE_ARCHIVED_SHIPMENTS
});

export const togglePlannedOrders = () => ({
  type: TOGGLE_PLANNED_ORDERS
});

export const switchTableComponent = component => ({
  type: SWITCH_TABLE_COMPONENT,
  component: component
});

export const toggleReport = (name, items) => ({
  type: TOGGLE_REPORT,
  reportName: name,
  reportItems: items
});
export const dismissReport = () => ({
  type: DISMISS_REPORT
});


// WEBPACK FOOTER //
// ./src/actions/ui_actions.js